const KEY = (address) => `dex-history:${(address || "guest").toLowerCase()}`;

export function loadHistory(address) {
  try {
    return JSON.parse(localStorage.getItem(KEY(address)) || "[]");
  } catch {
    return [];
  }
}

export function saveTx(address, entry) {
  const list = loadHistory(address);
  const next = [{ ...entry, ts: Date.now() }, ...list].slice(0, 50);
  localStorage.setItem(KEY(address), JSON.stringify(next));
  return next;
}

export function updateTxStatus(address, hash, patch) {
  const list = loadHistory(address);
  const next = list.map((t) => (t.hash === hash ? { ...t, ...patch } : t));
  localStorage.setItem(KEY(address), JSON.stringify(next));
  return next;
}
